/* mm-save-later.js — "Save for later / Send to me or my partner" (Jon, Nov 2 2026).
   One quiet button under the main Buy / Add to cart button, and "Save this package" in the cart.
   Nothing opens on its own: the sheet slides up only when the guest taps the button.
   Config comes from snippets/mm-save-later.liquid (window.mmSaveLater).
   The server (Modern HQ /api/save-later) re-reads every price from Shopify and sends ONE message.
   Partner sends: the partner's email/phone goes to HQ for that one message only. It is never passed
   to Google or Meta (mmLead is called only for "me" sends). */
(function () {
  'use strict';
  var C = window.mmSaveLater;
  if (!C || window.__mmSaveLaterReady) return;
  window.__mmSaveLaterReady = true;

  /* The private token in a saved link (128 random bits). The short MM-XXXX code is only for staff. */
  var TOKEN_RE = /^[A-Za-z0-9_-]{22}$/;
  var STORE_KEY = 'mmSaveStore', ME_KEY = 'mmSaveMe';
  var STORES = [
    { key: 'saskatoon-north', name: 'Saskatoon North', addr: '601 51st St E, Saskatoon' },
    { key: 'rosewood', name: 'Saskatoon Rosewood', addr: '3020 Meadows Pkwy #90, Saskatoon' },
    { key: 'regina-pow', name: 'Regina Prince of Wales', addr: '2030 Prince of Wales Dr, Regina' },
    { key: 'moose-jaw', name: 'Moose Jaw', addr: '27B McKenzie Ln, Moose Jaw' },
    { key: 'yorkton', name: 'Yorkton', addr: '12B Livingstone St, Yorkton' }
  ];
  var HOURS = 'Mon to Wed 10 to 6 · Thu and Fri 10 to 8 · Sat 10 to 6 · Sun 11 to 5';

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { var d = c / 100; return '$' + d.toLocaleString('en-CA', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function sizeName(t) {
    if (!t || /^default title$/i.test(t)) return '';
    var map = { TWXL: 'Twin XL', 'TWIN XL': 'Twin XL', RVQ: 'RV Queen' };
    return t.split('/').map(function (p) { p = p.trim(); return map[p.toUpperCase()] || p.toLowerCase().replace(/(^|[\s-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }); }).join(' · ');
  }
  /* Same short names the cart uses (keep in step with Modern HQ lib/save-later.ts DISPLAY_NAMES). */
  var NAMES = { 'modern-mattress-9-et-medium': 'The Modern 9-inch', 'modern-mattress-luna-mattress-collection': 'The Luna' };
  function nameOf(handle, title) { return NAMES[handle] || title; }
  function isNovember() { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Regina', month: 'numeric' }).format(new Date()) === '11'; } catch (e) { return false; } }

  function beacon(payload) {
    var body = JSON.stringify(Object.assign(payload, typeof window.mmAdIds === 'function' ? window.mmAdIds() : {}));
    try {
      if (!navigator.sendBeacon || !navigator.sendBeacon(C.endpoint + '/open', new Blob([body], { type: 'text/plain' }))) {
        fetch(C.endpoint + '/open', { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) {}
  }

  /* ── Arriving from a saved message ──
     ?mm_s=<token>  the bed / package link: report the visit (joins this phone to the save).
     ?mm_k=<token>  the "Yes, send me deals" button: ask once more on the page, and send ONLY
                    when they tap Yes (a mail scanner opening links can never confirm). */
  (function arrived() {
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var token = q.get('mm_s'), confirmToken = q.get('mm_k');
    if (token && TOKEN_RE.test(token)) beacon({ token: token });
    if (confirmToken && TOKEN_RE.test(confirmToken)) {
      var show = function () { dealsBar(confirmToken); };
      if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);
    }
    if (token || confirmToken) {
      try { q.delete('mm_s'); q.delete('mm_k'); var s = q.toString(); history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
    }
  })();

  function dealsBar(confirmToken) {
    var bar = document.createElement('div');
    bar.setAttribute('role', 'dialog');
    bar.setAttribute('aria-label', 'Confirm deals');
    bar.style.cssText = 'position:fixed;left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom));z-index:2147483000;max-width:480px;margin:0 auto;background:#0d0d0d;color:#fff;border:1px solid rgba(255,255,255,.14);border-radius:18px;padding:16px;box-shadow:0 12px 40px rgba(0,0,0,.5);font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    bar.innerHTML = '<div style="font-size:16px;font-weight:800">One more tap and you\'re in.</div>' +
      '<div style="font-size:13px;color:rgba(255,255,255,.68);margin:4px 0 12px;line-height:1.45">Just the odd deal, never every day. Stop any time.</div>' +
      '<div style="display:flex;gap:10px"><button type="button" data-yes style="flex:1;min-height:48px;border:0;border-radius:50px;background:#EB000C;color:#fff;font:inherit;font-size:15px;font-weight:800;cursor:pointer">Yes, I\'m in</button>' +
      '<button type="button" data-no style="min-height:48px;padding:0 18px;border:1.5px solid rgba(255,255,255,.3);border-radius:50px;background:transparent;color:#fff;font:inherit;font-size:15px;font-weight:700;cursor:pointer">Not now</button></div>';
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-yes]')) {
        beacon({ confirmToken: confirmToken });
        bar.innerHTML = '<div style="font-size:15px;font-weight:800;text-align:center;padding:6px 0">You\'re in. Thanks!</div>';
        setTimeout(function () { bar.remove(); }, 2200);
      } else if (e.target.closest('[data-no]')) {
        bar.remove();
      }
    });
    document.body.appendChild(bar);
  }

  if (!C.mode) return;

  /* ── Styles (injected once; nothing render-blocking) ── */
  var css = [
    '.mmsl-btn{display:flex;align-items:center;justify-content:center;gap:12px;width:100%;min-height:56px;margin:12px 0 0;padding:10px 18px;background:transparent;color:#fff;border:1.5px solid rgba(255,255,255,.32);border-radius:50px;font:inherit;cursor:pointer;text-align:left;transition:border-color .2s,background .2s}',
    '.mmsl-btn:hover,.mmsl-btn:focus-visible{border-color:#fff;background:rgba(255,255,255,.04);outline:none}',
    '.mmsl-btn svg{flex:none;width:20px;height:20px}',
    '.mmsl-btn b{display:block;font-size:15px;font-weight:800;line-height:1.2}',
    '.mmsl-btn small{display:block;font-size:12.5px;font-weight:500;color:rgba(255,255,255,.62);line-height:1.3;margin-top:1px}',
    '.mmsl-hint{font-size:12px;color:rgba(255,255,255,.5);text-align:center;margin:8px 0 0}',
    '.mmsl-wrap{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;visibility:hidden}',
    '.mmsl-wrap.on{visibility:visible}',
    '.mmsl-shade{position:absolute;inset:0;background:rgba(0,0,0,.6);opacity:0;transition:opacity .25s}',
    '.mmsl-wrap.on .mmsl-shade{opacity:1}',
    '.mmsl-sheet{position:relative;width:100%;max-width:520px;max-height:92vh;overflow-y:auto;-webkit-overflow-scrolling:touch;background:#0d0d0d;color:#fff;border-radius:22px 22px 0 0;border-top:1px solid rgba(255,255,255,.1);padding:10px 20px calc(22px + env(safe-area-inset-bottom));transform:translateY(100%);transition:transform .32s cubic-bezier(.16,1,.3,1);font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-sizing:border-box}',
    '.mmsl-wrap.on .mmsl-sheet{transform:translateY(0)}',
    '@media(prefers-reduced-motion:reduce){.mmsl-sheet,.mmsl-shade{transition:none}}',
    '.mmsl-grab{width:40px;height:4px;border-radius:4px;background:rgba(255,255,255,.25);margin:0 auto 14px}',
    '.mmsl-x{position:absolute;top:10px;right:10px;width:44px;height:44px;border:0;background:transparent;color:rgba(255,255,255,.7);font-size:26px;line-height:44px;cursor:pointer;border-radius:50%}',
    '.mmsl-ey{font-size:11px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:#EB000C}',
    '.mmsl-h{font-size:24px;font-weight:900;letter-spacing:-.4px;line-height:1.15;margin:6px 44px 6px 0;color:#fff}',
    '.mmsl-lede{font-size:14px;color:rgba(255,255,255,.68);line-height:1.5;margin:0 0 16px}',
    '.mmsl-item{display:flex;gap:14px;align-items:center;background:#161616;border:1px solid rgba(255,255,255,.08);border-radius:16px;padding:10px;margin-bottom:16px}',
    '.mmsl-item img{width:64px;height:64px;object-fit:contain;background:#000;border-radius:10px;flex:none}',
    '.mmsl-item .t{font-size:14.5px;font-weight:800;line-height:1.25}',
    '.mmsl-item .s{font-size:12.5px;color:rgba(255,255,255,.6);margin-top:2px}',
    '.mmsl-item .p{font-size:16px;font-weight:900;color:#22C55E;margin-top:4px}',
    '.mmsl-item .p s{font-size:12.5px;font-weight:500;color:rgba(255,255,255,.45);margin-left:6px}',
    '.mmsl-lines{background:#161616;border:1px solid rgba(255,255,255,.08);border-radius:16px;padding:4px 14px;margin-bottom:16px}',
    '.mmsl-ln{display:flex;justify-content:space-between;gap:12px;padding:10px 0;border-bottom:1px solid rgba(255,255,255,.07);font-size:13.5px}',
    '.mmsl-ln:last-child{border-bottom:0}',
    '.mmsl-ln .n{font-weight:700}.mmsl-ln .z{color:rgba(255,255,255,.55);font-size:12px;margin-top:1px}',
    '.mmsl-ln .v{color:#22C55E;font-weight:800;white-space:nowrap}',
    '.mmsl-ln.tot .n,.mmsl-ln.tot .v{font-size:16px;font-weight:900}',
    '.mmsl-lbl{display:block;font-size:12px;font-weight:700;color:rgba(255,255,255,.6);margin:0 0 6px}',
    '.mmsl-seg{display:flex;background:#1a1a1a;border-radius:999px;padding:4px;margin:0 0 14px}',
    '.mmsl-seg button{flex:1;min-height:40px;border:0;border-radius:999px;background:transparent;color:rgba(255,255,255,.65);font:inherit;font-size:14px;font-weight:700;cursor:pointer}',
    '.mmsl-seg button[aria-pressed="true"]{background:#fff;color:#000}',
    '.mmsl-seg button[disabled]{opacity:.4;cursor:default}',
    '.mmsl-in{display:block;width:100%;box-sizing:border-box;min-height:50px;margin:0 0 14px;padding:12px 14px;background:#111;color:#fff;border:1.5px solid rgba(255,255,255,.22);border-radius:14px;font:inherit;font-size:16px}',
    '.mmsl-in:focus{outline:none;border-color:#fff}',
    'select.mmsl-in{appearance:none;-webkit-appearance:none;background-image:linear-gradient(45deg,transparent 50%,#fff 50%),linear-gradient(135deg,#fff 50%,transparent 50%);background-position:calc(100% - 20px) 22px,calc(100% - 15px) 22px;background-size:5px 5px;background-repeat:no-repeat}',
    '.mmsl-chk{display:flex;gap:10px;align-items:flex-start;font-size:13.5px;color:rgba(255,255,255,.75);line-height:1.4;margin:2px 0 16px;cursor:pointer}',
    '.mmsl-chk input{width:20px;height:20px;margin:0;flex:none;accent-color:#EB000C}',
    '.mmsl-go{display:block;width:100%;min-height:54px;border:0;border-radius:50px;background:#EB000C;color:#fff;font:inherit;font-size:16px;font-weight:800;cursor:pointer}',
    '.mmsl-go[disabled]{opacity:.6;cursor:wait}',
    '.mmsl-fine{font-size:12px;color:rgba(255,255,255,.5);text-align:center;line-height:1.45;margin:12px 0 0}',
    '.mmsl-fine a{color:rgba(255,255,255,.7)}',
    '.mmsl-err{display:none;font-size:13.5px;color:#ff6b6b;margin:-4px 0 12px}',
    '.mmsl-err.on{display:block}',
    '.mmsl-hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}',
    '.mmsl-done{text-align:center;padding:12px 0 4px}',
    '.mmsl-tick{width:60px;height:60px;border-radius:50%;background:rgba(34,197,94,.15);color:#22C55E;display:flex;align-items:center;justify-content:center;margin:6px auto 14px}',
    '.mmsl-store{text-align:left;background:#161616;border:1px solid rgba(255,255,255,.08);border-radius:16px;padding:16px;margin:16px 0}',
    '.mmsl-store .k{font-size:11px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:#EB000C}',
    '.mmsl-store .nm{font-size:17px;font-weight:800;margin-top:4px}',
    '.mmsl-store .ad{font-size:13px;color:rgba(255,255,255,.62);margin-top:3px;line-height:1.45}',
    '.mmsl-alt{display:block;width:100%;min-height:50px;margin-top:10px;border:1.5px solid rgba(255,255,255,.3);border-radius:50px;background:transparent;color:#fff;font:inherit;font-size:15px;font-weight:700;cursor:pointer;text-decoration:none;line-height:47px;text-align:center}',
    'html.mmsl-lock,html.mmsl-lock body{overflow:hidden}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/></svg>';
  var TICK = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ── What is being saved, read at the moment they tap ── */
  function currentItems() {
    if (C.mode === 'bed') {
      var p = C.product, form = C._anchor && C._anchor.closest && C._anchor.closest('form');
      var inp = (form && form.querySelector('[name="id"]')) || document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
      var id = Number(inp && inp.value);
      var v = p.variants.filter(function (x) { return x.id === id; })[0] || p.variants.filter(function (x) { return x.id === p.selected; })[0] || p.variants[0];
      return Promise.resolve([{ handle: p.handle, variantId: v.id, qty: 1, title: nameOf(p.handle, p.title), size: sizeName(v.title), price: v.price, compare: v.compare_at_price > v.price ? v.compare_at_price : 0, image: v.image || p.image }]);
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      return (cart.items || []).filter(function (i) { return i.price > 0 && i.handle; }).slice(0, 12).map(function (i) {
        var orig = i.original_price || i.price, cmp = i.compare_at_price || 0;
        return { handle: i.handle, variantId: i.variant_id, qty: i.quantity, title: nameOf(i.handle, i.product_title), size: sizeName(i.variant_title || ''), price: orig, compare: cmp > orig ? cmp : 0, image: i.image };
      });
    });
  }

  /* ── The sheet ── */
  var wrap, sheet, lastFocus, state = { recipient: 'me', channel: C.sms ? 'sms' : 'email', items: [], openedAt: 0 };

  function storeOptions() {
    var saved = get(STORE_KEY);
    return '<option value="">Choose your store</option>' + STORES.map(function (s) { return '<option value="' + s.key + '"' + (s.key === saved ? ' selected' : '') + '>' + esc(s.name) + '</option>'; }).join('');
  }

  function itemBlock() {
    var it = state.items;
    if (C.mode === 'bed') {
      var i = it[0];
      return '<div class="mmsl-item">' + (i.image ? '<img src="' + esc(i.image) + (/\?/.test(i.image) ? '&' : '?') + 'width=160" alt="" width="64" height="64">' : '') +
        '<div><div class="t">' + esc(i.title) + '</div>' + (i.size ? '<div class="s">' + esc(i.size) + '</div>' : '') +
        '<div class="p">' + money(i.price) + (i.compare ? '<s>' + money(i.compare) + '</s>' : '') + '</div></div></div>';
    }
    var tot = 0;
    var rows = it.map(function (i) { tot += i.price * i.qty; return '<div class="mmsl-ln"><div><div class="n">' + esc(i.title) + (i.qty > 1 ? ' x ' + i.qty : '') + '</div>' + (i.size ? '<div class="z">' + esc(i.size) + '</div>' : '') + '</div><div class="v">' + money(i.price * i.qty) + '</div></div>'; }).join('');
    return '<div class="mmsl-lines">' + rows + '<div class="mmsl-ln tot"><div class="n">Total</div><div class="v">' + money(tot) + '</div></div></div>';
  }

  function formHtml() {
    var bed = C.mode === 'bed', me = state.recipient === 'me', sms = state.channel === 'sms';
    var title = 'Send it to you or your partner';
    var lede = me
      ? (C.sms ? 'We\'ll send it to you, price and all. Come try it whenever you\'re ready.' : 'We\'ll email it to you, price and all. Come try it whenever you\'re ready.')
      : 'They get one message with the price and where to lie on it together.';
    var rem = {};
    try { rem = me ? JSON.parse(get(ME_KEY) || '{}') || {} : {}; } catch (e) { rem = {}; }
    var field = sms
      ? '<label class="mmsl-lbl" for="mmsl-c">' + (me ? 'Your mobile number' : 'Their mobile number') + '</label><input class="mmsl-in" id="mmsl-c" name="phone" type="tel" inputmode="tel" autocomplete="' + (me ? 'tel' : 'off') + '" placeholder="(306) 555-0123" value="' + esc(me && rem.phone || '') + '" required>'
      : '<label class="mmsl-lbl" for="mmsl-c">' + (me ? 'Your email' : 'Their email') + '</label><input class="mmsl-in" id="mmsl-c" name="email" type="email" inputmode="email" autocomplete="' + (me ? 'email' : 'off') + '" placeholder="you@example.com" value="' + esc(me && rem.email || '') + '" required>';
    return '<div class="mmsl-ey">Save for later</div><h2 class="mmsl-h" id="mmsl-title">' + title + '</h2><p class="mmsl-lede">' + lede + '</p>' + itemBlock() +
      '<form class="mmsl-f" novalidate>' +
      '<span class="mmsl-lbl" id="mmsl-who">Send to</span><div class="mmsl-seg" role="group" aria-labelledby="mmsl-who"><button type="button" data-r="me" aria-pressed="' + me + '">Me</button><button type="button" data-r="partner" aria-pressed="' + !me + '">My partner</button></div>' +
      (me ? '' : '<label class="mmsl-lbl" for="mmsl-n">Your first name</label><input class="mmsl-in" id="mmsl-n" name="senderName" autocomplete="given-name" maxlength="30" placeholder="So they know it\'s from you" required>') +
      '<span class="mmsl-lbl" id="mmsl-how">Send by</span><div class="mmsl-seg" role="group" aria-labelledby="mmsl-how"><button type="button" data-c="email" aria-pressed="' + !sms + '">Email</button><button type="button" data-c="sms" aria-pressed="' + sms + '"' + (C.sms ? '' : ' disabled aria-disabled="true" title="Text is coming soon"') + '>Text</button></div>' +
      field +
      '<label class="mmsl-lbl" for="mmsl-s">Nearest store</label><select class="mmsl-in" id="mmsl-s" name="store" required>' + storeOptions() + '</select>' +
      (me ? '<label class="mmsl-chk"><input type="checkbox" name="consent"><span>Send me the odd deal too (optional)</span></label>' : '') +
      '<div class="mmsl-hp" aria-hidden="true"><label>Website<input name="website" tabindex="-1" autocomplete="off"></label></div>' +
      '<p class="mmsl-err" role="alert"></p>' +
      '<button class="mmsl-go" type="submit">' + (me ? 'Send it' : 'Send to my partner') + '</button>' +
      '<p class="mmsl-fine">' + (me ? 'One message, just this ' + (bed ? 'bed' : 'package') + '. See our <a href="/policies/privacy-policy">privacy policy</a>.' : 'We send one message and never add them to any list.') + '</p>' +
      '</form>';
  }

  function doneHtml(storeKey) {
    var s = STORES.filter(function (x) { return x.key === storeKey; })[0] || STORES[0];
    var dest = encodeURIComponent('Modern Mattress ' + s.addr + ', SK');
    return '<div class="mmsl-done"><div class="mmsl-tick">' + TICK + '</div><h2 class="mmsl-h" id="mmsl-title" style="margin:0 0 6px">' + (state.channel === 'sms' ? 'Sent. Check your texts.' : 'Sent. It\'s in your inbox.') + '</h2>' +
      '<p class="mmsl-lede" style="margin:0">' + (state.recipient === 'me' ? 'Check your ' + (state.channel === 'sms' ? 'texts' : 'inbox') + '. Show it when you come in.' : 'We sent it. They can show it at any store.') + '</p>' +
      '<div class="mmsl-store"><div class="k">Lie on it in person</div><div class="nm">Modern Mattress ' + esc(s.name) + '</div><div class="ad">' + esc(s.addr) + '<br>' + esc(HOURS) + '</div></div>' +
      '<a class="mmsl-go" style="display:block;text-decoration:none;line-height:54px;text-align:center" href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '" target="_blank" rel="noopener">Get directions</a>' +
      '<button type="button" class="mmsl-alt" data-close>Keep browsing</button></div>';
  }

  function render(html) { sheet.querySelector('.mmsl-body').innerHTML = html; }

  function build() {
    wrap = document.createElement('div');
    wrap.className = 'mmsl-wrap';
    wrap.innerHTML = '<div class="mmsl-shade" data-close></div><div class="mmsl-sheet" role="dialog" aria-modal="true" aria-labelledby="mmsl-title"><div class="mmsl-grab"></div><button type="button" class="mmsl-x" data-close aria-label="Close">&times;</button><div class="mmsl-body"></div></div>';
    document.body.appendChild(wrap);
    sheet = wrap.querySelector('.mmsl-sheet');
    wrap.addEventListener('click', function (e) {
      var t = e.target.closest('[data-close],[data-r],[data-c]');
      if (!t) return;
      if (t.hasAttribute('data-close')) return close();
      if (t.dataset.r && t.dataset.r !== state.recipient) { state.recipient = t.dataset.r; render(formHtml()); focusField(); }
      if (t.dataset.c && t.dataset.c !== state.channel) { state.channel = t.dataset.c; render(formHtml()); focusField(); }
    });
    wrap.addEventListener('submit', onSubmit);
    document.addEventListener('keydown', function (e) {
      if (!wrap.classList.contains('on')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trap(e);
    });
    /* Swipe down (from the top of the sheet) to close. */
    var y0 = null;
    sheet.addEventListener('touchstart', function (e) { y0 = sheet.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; var dy = e.touches[0].clientY - y0; if (dy > 0) sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    sheet.addEventListener('touchend', function (e) { if (y0 === null) return; var dy = e.changedTouches[0].clientY - y0; sheet.style.transform = ''; y0 = null; if (dy > 110) close(); });
  }

  function trap(e) {
    var f = sheet.querySelectorAll('button,a[href],input:not([tabindex="-1"]),select');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function focusField() { var el = sheet.querySelector('#mmsl-n') || sheet.querySelector('#mmsl-c'); if (el && !el.value) el.focus({ preventScroll: true }); }

  function open(e) {
    if (e) e.preventDefault();
    lastFocus = document.activeElement;
    if (!wrap) build();
    currentItems().then(function (items) {
      if (!items.length) return;
      state.items = items;
      state.openedAt = Date.now();
      render(formHtml());
      document.documentElement.classList.add('mmsl-lock');
      wrap.classList.add('on');
      setTimeout(function () { var x = sheet.querySelector('.mmsl-x'); if (x) x.focus({ preventScroll: true }); }, 50);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'mm_save_later_open', save_kind: C.mode }); } catch (err) {}
    }).catch(function () {});
  }
  function close() {
    if (!wrap) return;
    wrap.classList.remove('on');
    document.documentElement.classList.remove('mmsl-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function fail(msg) {
    var el = sheet.querySelector('.mmsl-err'), go = sheet.querySelector('.mmsl-go');
    if (el) { el.textContent = msg; el.classList.add('on'); }
    if (go) go.disabled = false;
  }

  function onSubmit(e) {
    e.preventDefault();
    var f = e.target, go = f.querySelector('.mmsl-go');
    var me = state.recipient === 'me', sms = state.channel === 'sms';
    var contact = (f.querySelector('#mmsl-c').value || '').trim();
    var store = f.querySelector('#mmsl-s').value;
    var name = me ? '' : (f.querySelector('#mmsl-n').value || '').trim();
    if (!me && !/^\p{L}+(?:[ '’-]\p{L}+)*$/u.test(name)) return fail('Add your first name so they know it\'s from you.');
    if (sms ? contact.replace(/\D/g, '').length < 10 : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(contact)) return fail(sms ? 'Check the mobile number.' : 'Check the email address.');
    if (!store) return fail('Choose the store nearest you.');
    go.disabled = true;
    var consentBox = f.querySelector('[name="consent"]');
    var consent = me && !!(consentBox && consentBox.checked);
    var ids = me && typeof window.mmAdIds === 'function' ? window.mmAdIds() : {};
    var payload = Object.assign({
      kind: C.mode, recipient: state.recipient, channel: state.channel, store: store, consentMarketing: consent,
      senderName: name || undefined, website: f.querySelector('[name="website"]').value, fillMs: Date.now() - state.openedAt,
      items: state.items.map(function (i) { return { handle: i.handle, variantId: i.variantId, qty: i.qty }; }),
      clickTags: me && typeof window.mmClickTags === 'function' ? window.mmClickTags() : []
    }, ids);
    payload[sms ? 'phone' : 'email'] = contact;
    fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) {
        if (r.status === 429) throw new Error('slow');
        if (r.status === 204) return { code: null };
        if (!r.ok) throw new Error('bad');
        return r.json();
      })
      .then(function (res) {
        put(STORE_KEY, store);
        if (me) put(ME_KEY, JSON.stringify(sms ? { phone: contact } : { email: contact }));
        track(res && res.code, me, sms ? { phone: contact } : { email: contact });
        render(doneHtml(store));
      })
      .catch(function (err) {
        fail(err && err.message === 'slow' ? 'You\'ve sent a few already. Try again in a little while.' : 'That didn\'t go through. Check it and try again, or call any store.');
      });
  }

  /* Google + Meta: only the guest's OWN contact, never a partner's. "send_bed" is not a primary
     source in mm-lead.js, so it never counts as the $200 Website lead. "Saved a bed" is its own
     conversion (label from Google Ads Command; empty = not fired yet). */
  function track(code, me, contact) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'mm_save_later_sent', save_kind: C.mode, save_recipient: state.recipient, save_channel: state.channel }); } catch (e) {}
    if (me && typeof window.mmLead === 'function') { try { window.mmLead(Object.assign({ source: C.mode === 'bed' ? 'send_bed' : 'send_package' }, contact)); } catch (e) {} }
    if (C.awLabel && code && typeof window.gtag === 'function') {
      try { window.gtag('event', 'conversion', { send_to: 'AW-302211231/' + C.awLabel, value: 50, currency: 'CAD', transaction_id: code }); } catch (e) {}
    }
  }

  /* ── Mount the button ── */
  function button(label, sub) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mmsl-btn';
    b.innerHTML = ICON + '<span><b>' + esc(label) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>';
    b.addEventListener('click', open);
    return b;
  }

  function mount() {
    if (document.querySelector('.mmsl-btn')) return true;
    var a = null;
    for (var i = 0; i < C.anchors.length && !a; i++) a = document.querySelector(C.anchors[i]);
    if (!a) return false;
    C._anchor = a;
    var bed = C.mode === 'bed';
    var host = bed ? ((a.closest && a.closest('form')) || a) : a;
    var box = document.createElement('div');
    box.className = 'mmsl';
    box.appendChild(button(bed ? 'Send this bed to me' : 'Send this setup to me'));
    if (bed) {
      var hint = document.createElement('p');
      hint.className = 'mmsl-hint';
      hint.textContent = 'Price, size and where to try it. Send it to your partner too.';
      box.appendChild(hint);
    }
    host.parentNode.insertBefore(box, host.nextSibling);
    return true;
  }

  if (!mount()) {
    var tries = 0, t = setInterval(function () { if (mount() || ++tries > 20) clearInterval(t); }, 250);
  }
  /* The cart redraws itself when a quantity changes; put the button back if it went. */
  if (C.mode === 'package' && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued || document.querySelector('.mmsl-btn')) return;
      queued = true;
      setTimeout(function () { queued = false; mount(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
